import React from 'react';
import { node, oneOfType, string } from 'prop-types';
import './preview-content.scss';

export const PreviewContent = ({ highlights }) => {
  return (
    <div className="preview-content-wrapper">
      <div className="mobile-highlights">
        {highlights}
      </div>
    </div>
  );
};

PreviewContent.displayName = 'PreviewContent';

PreviewContent.propTypes = {
  highlights: oneOfType([node, string]).isRequired
};
